import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-card-review-hsia-grid';
const html = `
<div
  class="container-page"
  data-attribute="container-page"
  data-enable-style="false"
  data-background-container="#FFFFFF"
  style="background-color: transparent;"
>
  <div class="wrap-grid-card">
    <div data-show="true" data-attribute="card-title" class="card-title" style="display: block;">
      <h2 style="text-align:center;">Over 200K+ Happy Customers</h2>
      <p style="text-align:center;">
        Best-of-the-best minimizer bra wardrobe staples, A perfect blend of&nbsp;<br />comfort, support, and a
        flattering sihouette.
      </p>
    </div>
    <div data-show="true" data-attribute="list-image-review" class="list-image-review">
      <div class="wrap-img">
        <img
          data-attribute="image-item-review"
          src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab10454d0040a7ce93fcbea.webp"
          alt=""
        />
      </div>
      <div class="wrap-img">
        <img
          data-attribute="image-item-review"
          src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab10458d0437a4d54a8e9f3.jpg"
          alt=""
        />
      </div>
      <div class="wrap-img">
        <img
          data-attribute="image-item-review"
          src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab1045b4bc84aed2f8c1f0c.webp"
          alt=""
        />
      </div>
      <div class="wrap-img">
        <img
          data-attribute="image-item-review"
          src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab10460b0f5e1918cbd2c04.webp"
          alt=""
        />
      </div>
      <div class="wrap-img">
        <img
          data-attribute="image-item-review"
          src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab1046339f49ad4366ade48.webp"
          alt=""
        />
      </div>
      <div class="wrap-img">
        <img
          data-attribute="image-item-review"
          src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab10466eb20324372243424.webp"
          alt=""
        />
      </div>
      <div class="wrap-img">
        <img
          data-attribute="image-item-review"
          src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab1046a4c89b62aec0c0053.jpg"
          alt=""
        />
      </div>
      <div class="wrap-img">
        <img
          data-attribute="image-item-review"
          src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab1046c7347e3efe7f174e5.webp"
          alt=""
        />
      </div>
    </div>
    <div
      data-show="true"
      data-attribute="list-review-text"
      data-color-star="#b75d3e"
      data-bg-item-review="#f7f7f7"
      class="list-review-text"
      style="--color-star: #b75d3e; --bg-item-review: #f7f7f7;"
    >
      <a href="#" data-attribute="item-review-text" class="wrap-item-review-text">
        <div data-attribute="star-item-review" data-value="5" class="wrap-star">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor"
            ></path>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor"
            ></path>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor"
            ></path>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor"
            ></path>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
        <div>
          <div data-attribute="text-item-review" class="text-review">
            <h3 style="text-align:center;">Perfect Fit</h3>
            <p style="text-align:center;">
              This is honestly the best bra I've ever worn. l can't even feel that I'm wearing it.It definitely
              minimizes-I did the jump and shake test, and the girls fully stayed inplace.
            </p>
          </div>
        </div>
        <div data-show="true" data-attribute="btn-item-review" class="btn-review-item" style="display: ;">
          <div data-attribute="btn-item-review-text" class="btn-item-review-text">SHOP THIS ITEM</div>
          <div data-attribute="icon-item-review" class="icon-bnt-review"></div>
        </div>
      </a>
      <a href="#" data-attribute="item-review-text" class="wrap-item-review-text">
        <div data-attribute="star-item-review" data-value="4" class="wrap-star">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor"
            ></path>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor"
            ></path>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor"
            ></path>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
        <div>
          <div data-attribute="text-item-review" class="text-review">
            <h3 style="text-align:center;">Perfect Fit</h3>
            <p style="text-align:center;">
              This is honestly the best bra I've ever worn. l can't even feel that I'm wearing it.It definitely
              minimizes-I did the jump and shake test, and the girls fully stayed inplace.
            </p>
          </div>
        </div>
        <div data-show="true" data-attribute="btn-item-review" class="btn-review-item" style="display: ;">
          <div data-attribute="btn-item-review-text" class="btn-item-review-text">SHOP THIS ITEM</div>
          <div data-attribute="icon-item-review" class="icon-bnt-review"></div>
        </div>
      </a>
      <a href="#" data-attribute="item-review-text" class="wrap-item-review-text">
        <div data-attribute="star-item-review" data-value="3" class="wrap-star">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor"
            ></path>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor"
            ></path>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
        <div>
          <div data-attribute="text-item-review" class="text-review">
            <h3 style="text-align:center;">Perfect Fit</h3>
            <p style="text-align:center;">
              This is honestly the best bra I've ever worn. l can't even feel that I'm wearing it.It definitely
              minimizes-I did the jump and shake test, and the girls fully stayed inplace.
            </p>
          </div>
        </div>
        <div data-show="true" data-attribute="btn-item-review" class="btn-review-item" style="display: ;">
          <div data-attribute="btn-item-review-text" class="btn-item-review-text">SHOP THIS ITEM</div>
          <div data-attribute="icon-item-review" class="icon-bnt-review"></div>
        </div>
      </a>
      <a href="#" data-attribute="item-review-text" class="wrap-item-review-text">
        <div data-attribute="star-item-review" data-value="5" class="wrap-star">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor"
            ></path>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor"
            ></path>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor"
            ></path>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor"
            ></path>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
        <div>
          <div data-attribute="text-item-review" class="text-review">
            <h3 style="text-align:center;">Perfect Fit</h3>
            <p style="text-align:center;">
              This is honestly the best bra I've ever worn. l can't even feel that I'm wearing it.It definitely
              minimizes-I did the jump and shake test, and the girls fully stayed inplace.
            </p>
          </div>
        </div>
        <div data-show="true" data-attribute="btn-item-review" class="btn-review-item" style="display: ;">
          <div data-attribute="btn-item-review-text" class="btn-item-review-text">SHOP THIS ITEM</div>
          <div data-attribute="icon-item-review" class="icon-bnt-review"></div>
        </div>
      </a>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css);
